import { useState, useEffect } from 'react'

export function useInstallPrompt() {
  const [installPrompt, setInstallPrompt] = useState(null)
  const [isInstalled, setIsInstalled] = useState(false)

  useEffect(() => {
    const checkInstalled = () => {
      const standalone = window.matchMedia('(display-mode: standalone)').matches
      const ios = window.navigator.standalone === true
      setIsInstalled(standalone || ios)
    }

    checkInstalled()

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault()
      console.log('[PWA] Install prompt available')
      setInstallPrompt(e)
    }

    const handleAppInstalled = () => {
      console.log('[PWA] App installed')
      setIsInstalled(true)
      setInstallPrompt(null)
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    window.addEventListener('appinstalled', handleAppInstalled)

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
      window.removeEventListener('appinstalled', handleAppInstalled)
    }
  }, [])

  const promptInstall = async () => {
    if (!installPrompt) {
      console.log('[PWA] No install prompt available')
      return false
    }

    try {
      installPrompt.prompt()
      const result = await installPrompt.userChoice
      console.log('[PWA] Install prompt result:', result.outcome)

      if (result.outcome === 'accepted') {
        setInstallPrompt(null)
        return true
      }
      return false
    } catch (error) {
      console.error('[PWA] Install prompt error:', error)
      return false
    }
  }

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  }

  return {
    canInstall: !!installPrompt,
    isInstalled,
    isIOS: isIOS(),
    promptInstall
  }
}
